import {select, takeEvery} from 'redux-saga/effects';

export function watch(selector, callback) {
  if (typeof selector != 'function') {
    throw 'selector must be a function for watch';
  }
  if (typeof callback != 'function') {
    throw 'callback must be a function for watch';
  }

  let prev = defaultValue;

  return takeEvery('*', function* (action) {
    const now = yield select(selector);
    if (prev === defaultValue || now !== prev) {
      const args = [ now, prev === defaultValue ? undefined : prev, action ];
      prev = now;
      yield callback.apply(null, args);
    }
  });
}

const defaultValue = '___undefined___';
